var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","color":"grey lighten-2"}},[_vm._v("Overview")]),_vm._v(" Showcase Statistics ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }